<template>
  <div class="">
    <div  tyle="max-height: 252px;overflow: hidden;" class="relative" :style="mainStyle">
      <div v-if="data.type=='text'" :style="textStyle" style="padding:12px 40px;min-height: 50px;border-bottom: 1px solid #E7E9EB;">
        <span style="font-family: inherit;">
          {{data.text}}
        </span>
      </div>
      <div v-if="data.type=='image'" style="height: 186px">
        <img v-if="!data.image" src="@/assets/img/header-img.png" :alt="title" width="100%" height="186"/>
        <div v-else-if="data.image=='none'" style="height: 186px"></div>
        <img v-else :src="data.image!='none'?convertDownloadUrl(data.image):''" :alt="title" width="100%" height="186"/>
      </div>
      <div v-if="data.type=='carousel'" style="min-height: 186px" :class="{'carousel-out':data.carouselType == 'out'}">
        <el-carousel height="186px" v-if="data.carouselImageList" :indicator-position="indicatorPosition">
          <el-carousel-item v-for="item in data.carouselImageList" :key="item.url">
            <img :src="convertDownloadUrl(item.url)" :alt="title" width="100%" style="height: 186px"/>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
  </div>
</template>

<script>
import { busGetters } from 'dygc'
export default {
  name: 'DisplayHeader',
  components: { },
  props: {
    themeHeader: {
      type: Object,
      default: ()=>({})
    },
  },
  computed: {
    textStyle() {
      return {
        color: this.data.textColor,
        fontFamily: this.data.textFamily,
        fontWeight: this.data.textWeight?600:400,
        fontSize: this.data.textSize,
        lineHeight: '30px',
        boxSizing: 'border-box'
      }
    },
    mainStyle() {
      return {
        textAlign: this.data.align,
        backgroundColor: this.data.backgroundColor
      }
    },
    title() {
      return this.survey.title
    },
    ...busGetters(['survey'])
  },
  created() {
    //console.log('66666',this.themeHeader)
    if(this.themeHeader?.type) {
      this.data = this.themeHeader
      if(this.data.carouselType == 'in') {
        this.indicatorPosition = null
        this.indicatorToBack()
      } else if(this.data.carouselType == 'out'){
        this.indicatorPosition = 'outside'
        this.$nextTick(()=>{
          this.indicatorToimage()
        })
      }
    }
    //this.init()
  },
  data() {
    return {
      indicatorPosition: null,
      data: {
        show: true,
        backgroundColor: '#ffffff',
        type: 'image',
        align: '2',
        text: '',
        textColor: "#333333",
        textFamily: 'inherit',
        textSize: '14px',
        textWeight: false,
        carouselType: 'in',
        carouselImageList: [
          {
            url: '',
            fileName: ''
          }
        ],
      },
    }
  },
  methods: {
    convertDownloadUrl(url) {
      return window.location.origin + '/fill/api/v1/download?fileName=' + url
    },
    // 将轮播图指示器渲染成图片
    indicatorToimage() {
      let a = document.querySelectorAll(".el-carousel__button")
      //console.log('a', a)
      //console.log('carouselImageList', this.data.carouselImageList)
      if(a.length>0) {
        for (let i in this.data.carouselImageList){
        
          let img0 = a[i].querySelector("img")
          if(img0) {
            a[i].removeChild(img0)
          }
        
          //添加一个img
          let img = document.createElement('img')
          img.src = this.convertDownloadUrl(this.data.carouselImageList[i].url)
          img.width = 72
          img.height = 40
          //加到button里面
          a[i].appendChild(img)
        }
      
      }
      
    },
    indicatorToBack() {
      let a = document.querySelectorAll(".el-carousel__button")
      if(a.length>0) {
        for (let i in this.data.carouselImageList){
          let img0 = a[i].querySelector("img")
          a[i].removeChild(img0)
        }
      }
    }
  },
  watch: {
    themeHeader: {
      handler(v) {
        //console.log('555556667779999900000', this.themeHeader)
        if(this.themeHeader?.type) {
          this.data = this.themeHeader
          if(this.data.carouselType == 'in') {
            this.indicatorPosition = null
            this.indicatorToBack()
          } else if(this.data.carouselType == 'out'){
            this.indicatorPosition = 'outside'
            this.$nextTick(()=>{
              this.indicatorToimage()
            })
          }
        }
       
      },
      deep: true
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-carousel__indicator--horizontal .el-carousel__button {
  width: 10px;
  height: 10px;
  background: transparent;
  border: 1px solid #ffffff;
  border-radius: 50%;
  opacity: 0.5;
}  
::v-deep .el-carousel__indicator--horizontal.is-active .el-carousel__button{
  width: 10px;
  height: 10px;
  background: #ffffff;
  border-radius: 50%;
  opacity: 1;
}
.carousel-out {
  ::v-deep .el-carousel__indicator--horizontal {
    margin-right: 66px;
    .el-carousel__button {
      position: relative;
      top: 2px;
    }    
  }
  ::v-deep .el-carousel__button img{
    border-radius: 4px;
    position: relative;
    top: -2px;
    left: -2px;
  }
  .el-carousel--horizontal {
    //overflow-x: unset;
  }
  ::v-deep .el-carousel__indicators--outside {
    padding-bottom: 11px;
    //background-color: #F5F5F5;
  }
  
}
</style>

  
  